import React from 'react'

import { Page } from '../../../common/components/sections'
import { APP_ROUTES, ROLES } from '../../../common/constants'
import { useDocumentTitle } from '../../../common/hooks'

import { useUserHasRoles } from '../../../account/hooks'
import {
  MenuCurationTaskScrapingUserFilters,
  MenuCurationTasksFilters,
  MenuCurationTasksSorters,
  MenuCurationTasksTable,
} from '../sections'

const MenuCurationTasksPage = () => {
  useDocumentTitle(APP_ROUTES.MENUS.label)
  const isScrapingUser = useUserHasRoles([ROLES.SCRAPING.value])

  return (
    <Page>
      {isScrapingUser ? (
        <MenuCurationTaskScrapingUserFilters />
      ) : (
        <MenuCurationTasksFilters />
      )}
      <MenuCurationTasksSorters />
      <MenuCurationTasksTable />
    </Page>
  )
}

export default MenuCurationTasksPage
